import React, { useMemo, useState } from "react";
import { Box, Typography, IconButton, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import Topbar from "../../../../scenes/global/Topbar";

const mockDataTeam = [
  {
    id: 1,
    ClientID: "16",
    OrganizationID: "23",
    Provider: "OpenAI",
    Modelname: "gpt-3.5-turbo-16k",
    APIKey: "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",
    Version: "",
    CreatedDate: "2024-07-16 08:57:30",
    LastUpdatedDate: "2024-07-16 08:57:30",
  },
  {
    id: 2,
    ClientID: "16",
    OrganizationID: "23",
    Provider: "OpenAI",
    Modelname: "gpt-3.5-turbo-16k",
    APIKey: "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",
    Version: "",
    CreatedDate: "2024-07-16 08:57:30",
    LastUpdatedDate: "2024-07-16 08:57:30",
  },
  {
    id: 3,
    ClientID: "16",
    OrganizationID: "23",
    Provider: "OpenAI",
    Modelname: "gpt-3.5-turbo-16k",
    APIKey: "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",
    Version: "",
    CreatedDate: "2024-07-16 08:57:30",
    LastUpdatedDate: "2024-07-16 08:57:30",
  },
  {
    id: 4,
    ClientID: "16",
    OrganizationID: "23",
    Provider: "OpenAI",
    Modelname: "gpt-3.5-turbo-16k",
    APIKey: "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",
    Version: "",
    CreatedDate: "2024-07-16 08:57:30",
    LastUpdatedDate: "2024-07-16 08:57:30",
  },
  {
    id: 5,
    ClientID: "16",
    OrganizationID: "23",
    Provider: "OpenAI",
    Modelname: "gpt-3.5-turbo-16k",
    APIKey: "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",
    Version: "",
    CreatedDate: "2024-07-16 08:57:30",
    LastUpdatedDate: "2024-07-16 08:57:30",
  },
];

const LlmModuleInventory = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [filterModel, setFilterModel] = useState({
    items: [],
  });

  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEdit = () => {
    console.log("Editing client:", currentRow);
  };

  const handleDelete = () => {
    console.log("Deleting client:", currentRow);
  };

  const columns = [
    // { field: "id", headerName: "ID" },
    {
      field: "ClientID",
      headerName: "Client ID",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "OrganizationID",
      headerName: "Organization ID",
      flex: 1,
    },
    {
      field: "Provider",
      headerName: "Provider",
      flex: 1,
    },
    {
      field: "Modelname",
      headerName: "Model Name",
      flex: 1,
    },
    {
      field: "APIKey",
      headerName: "API Key",
      flex: 1,
    },
    {
      field: "Version",
      headerName: "Version",
      flex: 1,
    },
    {
      field: "CreatedDate",
      headerName: "Created Date",
      flex: 1,
    },
    {
      field: "LastUpdatedDate",
      headerName: "Last Updated Date",
      flex: 1,
    },

    {
      field: "action",
      headerName: "Action",
      renderCell: ({ row }) => (
        <div style={{ display: "flex" }}>
          <IconButton
            onClick={() => handleEdit(row.original)}
            style={{ color: "#6870fa", fontSize: "12px" }}
          >
            <BorderColorIcon />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(row.original)}
            style={{ color: "red", fontSize: "12px" }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="mt-4">
        <Topbar />
      </div>

      <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
        <div className="p-4 flex items-center justify-between">
          <h2 className="">LLM Model Inventory</h2>
          <div
            style={{ backgroundColor: colors.blueAccent[500] }}
            className="text-white px-4 py-2 rounded-sm"
          >
            <button onClick={openModal} className="font-medium">
              {" "}
              <AddIcon /> Add
            </button>
          </div>
        </div>

        <Box
          m="0 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <DataGrid
            checkboxSelection
            rows={mockDataTeam}
            columns={columns}
            filterModel={filterModel}
            onFilterModelChange={handleFilterChange}
          />
        </Box>

        {/* // add client modal pop up  */}
        <div
          className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
            isModalOpen ? "block" : "hidden"
          }`}
        >
          <div className="flex justify-center items-center min-h-screen">
            <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
              <h2 className="text-2xl text-center font-semibold mb-4">
                Add API Key
              </h2>

              <form>
                {/* Client Name */}

                <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 mb-3">
                  <div className="mb-3">
                    <label
                      htmlFor="clientName"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select Client
                    </label>
                    <div class="w-full max-w-sm min-w-[200px]">
                      <div class="relative">
                        <select class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer">
                          <option value="brazil">Select Client</option>
                          <option value="bucharest">Bucharest</option>
                          <option value="london">London</option>
                          <option value="washington">Washington</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.2"
                          stroke="currentColor"
                          class="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Client Code */}
                  <div className="mb-3">
                    <label
                      htmlFor="clientCode"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select Organization
                    </label>
                    <div class="w-full max-w-sm min-w-[200px]">
                      <div class="relative">
                        <select class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer">
                          <option value="brazil">Select Organization</option>
                          <option value="bucharest">Bucharest</option>
                          <option value="london">London</option>
                          <option value="washington">Washington</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.2"
                          stroke="currentColor"
                          class="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="clientCode"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Select Module
                    </label>
                    <div class="w-full max-w-sm min-w-[200px]">
                      <div class="relative">
                        <select class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer">
                          <option value="brazil">Select Module</option>
                          <option value="bucharest">Bucharest</option>
                          <option value="london">London</option>
                          <option value="washington">Washington</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.2"
                          stroke="currentColor"
                          class="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      API Key
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      placeholder="API Key"
                    />
                  </div>
                </div>

                <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Submit and Close Buttons */}
                  <div className="col-span-2 flex justify-between space-x-4">
                    <button
                      type="submit"
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Submit
                    </button>
                    <button
                      onClick={closeModal}
                      className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                    >
                      Close Modal
                    </button>
                  </div>
                </div>
              </form>

              {/* Close button */}
            </div>
          </div>
        </div>
      </Box>
    </>
  );
};

export default LlmModuleInventory;
